import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';

import { spotSymbolSocketBunja, tradeSymbolBunja } from '../../symbol';
import { Ddd } from './ddd';
import { RightLayout } from './right-layout';

export const SymbolRightSpot = () => {
  const { canRenderSymbolRightSpotAtom } = useBunja(symbolRightSpotBunja);
  const canRenderSymbolRightSpot = useAtomValue(canRenderSymbolRightSpotAtom);
  if (!canRenderSymbolRightSpot) return;

  return (
    <RightLayout>
      <High24h />
      <Low24h />
      <Volume24h />
      <Turnover24h />
    </RightLayout>
  );
};

const symbolRightSpotBunja = bunja(() => {
  const { pricePrecisionAtom, symbolInfoAtom } = bunja.use(tradeSymbolBunja);
  const { getTickerAtom } = bunja.use(spotSymbolSocketBunja);

  const canRenderSymbolRightSpotAtom = atom((get) => Boolean(get(getTickerAtom)));
  const high24hAtom = atom((get) => get(getTickerAtom)?.high24h);
  const low24hAtom = atom((get) => get(getTickerAtom)?.low24h);
  const volume24hAtom = atom((get) => get(getTickerAtom)?.volume24h);
  const turnover24hAtom = atom((get) => get(getTickerAtom)?.turnover24h);
  const displayShortNameAtom = atom((get) => get(symbolInfoAtom)?.displayShortName);

  return {
    canRenderSymbolRightSpotAtom,
    pricePrecisionAtom,
    high24hAtom,
    low24hAtom,
    volume24hAtom,
    turnover24hAtom,
    displayShortNameAtom,
  };
});
symbolRightSpotBunja.debugLabel = 'symbolRightSpotBunja';

const High24h = () => {
  const { high24hAtom, pricePrecisionAtom } = useBunja(symbolRightSpotBunja);
  const high24h = useAtomValue(high24hAtom);
  const pricePrecision = useAtomValue(pricePrecisionAtom);

  return (
    <Ddd
      dt={<FormattedMessage id='Autogen_common.r251126.s_24h_high' />}
      dd={<Formatted.Number value={high24h} precision={pricePrecision} toFixed />}
    />
  );
};

const Low24h = () => {
  const { low24hAtom, pricePrecisionAtom } = useBunja(symbolRightSpotBunja);
  const low24h = useAtomValue(low24hAtom);
  const pricePrecision = useAtomValue(pricePrecisionAtom);

  return (
    <Ddd
      dt={<FormattedMessage id='Autogen_common.r251126.s_24h_low' />}
      dd={<Formatted.Number value={low24h} precision={pricePrecision} toFixed />}
    />
  );
};

const Volume24h = () => {
  const { volume24hAtom, displayShortNameAtom } = useBunja(symbolRightSpotBunja);
  const volume24h = useAtomValue(volume24hAtom);
  const displayShortName = useAtomValue(displayShortNameAtom);

  return (
    <Ddd
      dt={
        <FormattedMessage
          id='Autogen_common.r251126.s_24h_volume_symbolInfo_displayShortName'
          values={{ symbolInfo_displayShortName: displayShortName }}
        />
      }
      dd={<Formatted.ShortNumber value={volume24h} toFixed zeroString='-' />}
    />
  );
};

const Turnover24h = () => {
  const { turnover24hAtom } = useBunja(symbolRightSpotBunja);
  const turnover24h = useAtomValue(turnover24hAtom);

  return (
    <Ddd
      dt={<FormattedMessage id='Autogen_common.r251126.s_24h_turnover_USDT' />}
      dd={<Formatted.ShortNumber value={turnover24h} toFixed zeroString='-' />}
    />
  );
};
